export const getListOfGatewayAndPrice = {
  GET_LIST_OF_GATEWAY_AND_PRICE_REQUEST: "GET_LIST_OF_GATEWAY_AND_PRICE_REQUEST",
  GET_LIST_OF_GATEWAY_AND_PRICE_SUCCESS: "GET_LIST_OF_GATEWAY_AND_PRICE_SUCCESS",
  GET_LIST_OF_GATEWAY_AND_PRICE_ERROR: "GET_LIST_OF_GATEWAY_AND_PRICE_ERROR",
};

export const editGatewayAndPrice = {
  EDIT_GATEWAY_AND_PRICE_REQUEST: "EDIT_GATEWAY_AND_PRICE_REQUEST",
  EDIT_GATEWAY_AND_PRICE_SUCCESS: "EDIT_GATEWAY_AND_PRICE_SUCCESS",
  EDIT_GATEWAY_AND_PRICE_ERROR: "EDIT_GATEWAY_AND_PRICE_ERROR",
};
